
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upsc-admission-anna-nagar",
      function () {
        return require("private-next-pages/upsc-admission-anna-nagar/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upsc-admission-anna-nagar"])
      });
    }
  